import { Button } from "@/components/ui/button"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import type { AssetUsageRow, AssetOption } from "./types"

interface AssetPickerProps {
  rows: AssetUsageRow[]
  assets: AssetOption[]
  onChange: (rows: AssetUsageRow[]) => void
}

export default function AssetPicker({ rows, assets, onChange }: AssetPickerProps) {
  const addRow = () => {
    onChange([...rows, { production_asset_id: "" }])
  }

  const setRow = (index: number, patch: Partial<AssetUsageRow>) => {
    onChange(rows.map((r, i) => (i === index ? { ...r, ...patch } : r)))
  }

  const removeRow = (index: number) => {
    onChange(
      rows.map((r, i) => {
        if (i !== index) return r
        return r.id ? { ...r, _destroy: true } : { ...r, _destroy: true, production_asset_id: "" }
      })
    )
  }

  const visible = rows.filter((r) => !r._destroy)

  return (
    <div className="space-y-2">
      {visible.length === 0 && (
        <p className="text-sm text-gray-500">
          Aucun équipement lié. Ajoutez écrans, cadres et autres outils amortis.
        </p>
      )}
      {rows.map((row, index) => {
        if (row._destroy) return null
        return (
          <div key={index} className="flex items-center gap-2">
            <Select
              value={
                row.production_asset_id === ""
                  ? undefined
                  : String(row.production_asset_id)
              }
              onValueChange={(v) =>
                setRow(index, { production_asset_id: Number(v) })
              }
            >
              <SelectTrigger className="h-9 w-72">
                <SelectValue placeholder="Choisir un équipement" />
              </SelectTrigger>
              <SelectContent>
                {assets.map((a) => (
                  <SelectItem key={a.id} value={String(a.id)}>
                    {a.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => removeRow(index)}
            >
              Retirer
            </Button>
          </div>
        )
      })}
      <Button type="button" variant="outline" size="sm" onClick={addRow}>
        + Ajouter un équipement
      </Button>
    </div>
  )
}
